import { render, staticRenderFns } from "./WordsOfWisdomSimple.vue?vue&type=template&id=51d77b10&scoped=true&"
import script from "./WordsOfWisdomSimple.vue?vue&type=script&lang=js&"
export * from "./WordsOfWisdomSimple.vue?vue&type=script&lang=js&"
import style0 from "./WordsOfWisdomSimple.vue?vue&type=style&index=0&id=51d77b10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d77b10",
  null
  
)

export default component.exports